import React from 'react';

import { NameCell, SortCell } from '../../../../../shared/components/DataTable';

const caseColumn = {
  accessorKey: 'clientTask.task.name',
  header: ({ column }) => <SortCell column={column} label="Case" />,
};

const clientColumn = {
  accessorKey: 'clientTask.client.fullName',
  cell: ({ row }) => <NameCell person={row.original.clientTask.client} />,
  header: ({ column }) => <SortCell column={column} label="Client" />,
};

const channelColumn = {
  accessorKey: 'channel',
  header: ({ column }) => <SortCell column={column} label="Channel" />,
};

const sentAtColumn = {
  accessorKey: 'sentAt',
  header: ({ column }) => <SortCell column={column} label="Sent at" />,
};

const columns = [caseColumn, clientColumn, channelColumn, sentAtColumn];

export default columns;
